export default __webpack_public_path__ + "static/media/maavuruimageimage2.82abc4b5.jpg";